import { Remarkable } from 'remarkable';
import React, { useState,useRef,useEffect } from "react";
import "./ChatComponent.css";
import { Card, Typography } from "@mui/material";
import CardContent from '@mui/material/CardContent';
import PsychologyAltTwoToneIcon from '@mui/icons-material/PsychologyAltTwoTone';
import AssistantSharpIcon from '@mui/icons-material/AssistantSharp';
import DragIndicatorTwoToneIcon from '@mui/icons-material/DragIndicatorTwoTone';
import TextSizeContext from "../../api/common/components/TextSizeContext";
// import DoubleClickDialog from '../../api/common/components/clickDialogue';
interface ChatEntry {
  role: "user" | "bot";
  text: string;
}

interface Props {
  chatHistory: ChatEntry[];
  handleLike?: (index: number) => void;
  handleDislike?: (index: number) => void;
  likes?: ("like" | "dislike" | null)[];
  isLoading: boolean;
}


export default function ChatHistory({ chatHistory, handleLike, handleDislike, likes, isLoading }: Props) {

  const chatHistoryRef = useRef<HTMLDivElement>(null);
  
    // Scroll to bottom function
    const scrollToBottom = () => {
      if (chatHistoryRef.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
      }
    };
  
    useEffect(() => {
      scrollToBottom();
    }, [chatHistory]);

  // Convert Markdown text to HTML

  return (
    <>
        <div ref={chatHistoryRef} style={{ maxHeight: '400px', overflowY: 'auto' }}>

        {chatHistory.map((entry, index) => (
          <div key={index}>
            {entry.role === "user" ? (
              <Typography>
                
                 <PsychologyAltTwoToneIcon /> <TextSizeContext context={entry.text} ></TextSizeContext><DragIndicatorTwoToneIcon/>
              </Typography>
            ) : (
              <Card>
                <CardContent className="bot-response">
               {/* <DoubleClickDialog/> */}
                  {/* Use dangerouslySetInnerHTML to render the HTML */}
                 <AssistantSharpIcon/> <TextSizeContext context={entry.text}></TextSizeContext>
                
                </CardContent>
              </Card>
            )}
          </div>
        ))}
        {isLoading && (
          <p className="text-info">
            <strong>loading: </strong>...
          </p>
        )}
      </div>
    </>
  );
}
